import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=49dd33b2&scoped=true&style=padding-left%3A100px%3B"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"
import style0 from "./reset_password.vue?vue&type=style&index=0&id=49dd33b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dd33b2",
  null
  
)

export default component.exports